export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden" style={{ height: '85vh' }}>
      <div className="absolute inset-0 bg-gradient-to-br from-teal-50/40 via-blue-50/30 to-white"></div>
      
      <div className="absolute inset-0 bg-gradient-to-b from-black/5 via-transparent to-transparent"></div>
      
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-1/2 h-full">
        <div className="relative w-full h-full flex items-center justify-center">
          <div className="absolute w-96 h-96 rounded-full opacity-20" style={{ background: 'radial-gradient(circle, #0A4D4D 0%, transparent 70%)', top: '10%', right: '15%' }}></div>
          <div className="absolute w-80 h-80 rounded-full opacity-15" style={{ background: 'radial-gradient(circle, #3B82F6 0%, transparent 70%)', bottom: '15%', right: '25%' }}></div>
          
          <div className="relative z-10" style={{ transform: 'rotate(-8deg)' }}>
            <img 
              src="https://public.readdy.ai/ai/img_res/5bed6baa14c1cc65731feadf41f61a39.jpg" 
              alt="iOS App Interface"
              className="w-80 h-auto object-contain"
              style={{ 
                filter: 'drop-shadow(0px 40px 80px rgba(10, 77, 77, 0.15))',
                maxWidth: '320px'
              }}
            />
          </div>
        </div>
      </div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-8 w-full">
        <div className="w-1/2 pl-12">
          <div 
            className="inline-block px-4 py-2 rounded-md mb-12"
            style={{ backgroundColor: '#E8F4F4', color: '#0A4D4D' }}
          >
            <span className="text-xs uppercase tracking-wide font-medium">iOS Development Experts</span>
          </div>
          
          <h1 className="mb-10" style={{ fontFamily: 'Playfair Display, serif', lineHeight: '1.15' }}>
            <div className="text-7xl font-normal mb-2" style={{ color: '#1A1A1A' }}>
              Crafting Premium
            </div>
            <div className="text-7xl italic font-light" style={{ color: '#4A4A4A' }}>
              iOS Experiences
            </div>
          </h1>
          
          <p className="text-lg leading-relaxed max-w-lg" style={{ color: '#6B6B6B', lineHeight: '1.7' }}>
            A team of experts developing modern applications for the iOS platform. Our products are designed to enhance user experience and improve the security of mobile devices.
          </p>
        </div>
      </div>
    </section>
  );
}